import { render } from "./layout_with_left_menu.vue?vue&type=template&id=bede5ad4&scoped=true"
import script from "./layout_with_left_menu.vue?vue&type=script&lang=js"
export * from "./layout_with_left_menu.vue?vue&type=script&lang=js"

import "./layout_with_left_menu.vue?vue&type=style&index=0&id=bede5ad4&lang=scss"
import "./layout_with_left_menu.vue?vue&type=style&index=1&id=bede5ad4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bede5ad4"]])

export default __exports__